/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { Link } from 'gatsby';
import { SocialIcons } from 'components/SocialIcons/SocialIcons';
import Call from 'assets/svg/call.svg';
import Calendar from 'assets/svg/calendar.svg';
import Clock from 'assets/svg/clock.svg';
import Mail from 'assets/svg/sms.svg';
import { ScrollTop } from 'components';
import Location from 'assets/svg/location.svg';
import Logo from 'assets/svg/footerlogo.svg';
import ReactMarkdown from 'react-markdown';
import { GlobalType } from 'types/GlobalType';

export const Footer = ({ data }: { data: GlobalType }) => {
  const footer = data?.strapiGlobal?.footer;
  const socialMediaLinks = data?.strapiGlobal?.socialMediaLinks;

  const {
    contactMail,
    copyrightMessae,
    officeWorkingDays,
    officeWorkingTime,
    phoneNumber,
    phoneText,
    address,
    footerMenuTitle,
    footerLinks,
    footerContent,
  } = footer || {};
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-wrapper">
          <div className="footer-address">
            <div className="footer-logo">
              <Link to="/">
                <Logo />
              </Link>
            </div>
            <SocialIcons socialMediaLinks={socialMediaLinks || {}} />
            <div className="footer-details">
              <div className="footer-details-items">
                <address>
                  <p className="footer-details-content">
                    <span>
                      <Location />
                    </span>
                    {address?.data?.address}
                  </p>
                </address>
              </div>
              <div className="footer-details-items">
                <p className="footer-details-content">
                  <span>
                    <Calendar />
                  </span>
                  {officeWorkingDays}
                </p>
                <p className="footer-details-content number-font" />
              </div>
              <div className="footer-details-items">
                <p className="footer-details-content">
                  <span className="footer-clock">
                    <Clock />
                  </span>
                  {officeWorkingTime}
                </p>
              </div>
              <div className="footer-details-items">
                <p className="footer-details-content">
                  <span>
                    <Call />
                  </span>
                  <a href={`tel:${phoneNumber}`}>{phoneText}</a>
                </p>
              </div>
              <div className="footer-details-items">
                <p className="footer-details-content">
                  <span>
                    <Mail />
                  </span>
                  <a href={`mailto:${contactMail}`}>{contactMail}</a>
                </p>
              </div>
            </div>
          </div>
          <div className="footer-wrapper-content form-hidden">
            <div className="footer-menu">
              <div className="footer-menu-title">{footerMenuTitle}</div>
              <ul className="footer-menu-list">
                {footerLinks?.map((item: any) => (
                  <li className="menu-list-item" key={item.link}>
                    <Link to={`/${item.link}`} className="menu-list-item-link">
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="footer-content">
              {footerContent?.data?.footerContent && (
                <ReactMarkdown>
                  {footerContent.data.footerContent}
                </ReactMarkdown>
              )}
            </div>
          </div>
        </div>

        <div className="footer-copyright">
          {copyrightMessae}
          <p className="footer-tag">
            Designed and built by{' '}
            <a href="https://ozzi.tech" target="_blank">
              Ozzitech
            </a>
          </p>
        </div>
      </div>
      <ScrollTop />
    </footer>
  );
};
